
export default {
  data() {
    return {
      versionNumber: '{{POST_BUILD_ENTERS_HASH_HERE}}',
    }
  }
};